module.exports = __webpack_public_path__ + "img/residence_u_pirellu.8fa93f02.jpg";